import { lazyGetAccountInformation } from 'owa-storage-store';
import { trace } from 'owa-trace';
import getFolderStorageInformation from 'owa-storage-option/lib/actions/getFolderStorageInformation';
import { isFeatureEnabled } from 'owa-feature-flags';
import { logUsage } from 'owa-analytics';

export async function loadStorageInformation(): Promise<boolean> {
    const isShowingMailboxCleanup = isFeatureEnabled('tri-mailboxCleanup');
    logUsage('MailboxCleanup_Impression', [isShowingMailboxCleanup]);

    try {
        const storagePromises: Promise<any>[] = [];
        storagePromises.push(lazyGetAccountInformation.importAndExecute());
        if (isShowingMailboxCleanup) {
            storagePromises.push(getFolderStorageInformation());
        }
        await Promise.all(storagePromises);
        return true;
    } catch (e) {
        trace.warn(e.message);
        return false;
    }
}
